import LocalSessionStore from './LocalSessionStore';

export class LocalSessionPersister {
  constructor(name) {
    this.stores = {};
    this.debug = false;
    this.name = name || 'LocalSessionPersister';
    this.version = 1;
  }

  setDebug(onOrOff) {
    this.debug = Boolean(onOrOff);
    Object.values(this.stores).forEach((s) => s.setDebug(onOrOff));
  }

  debugMsg(...args) {
    if (this.debug || window.showAtsDebugMessage === true) {
      // eslint-disable-next-line no-console
      console.log(`[${this.name}_${this.version}]`, ...args);
    }
  }

  /**
   * This will delete the indexedDB completely. Only use this for logout.
   */
  kill() {
    console.warn(`No need to call \`kill\` on ${this.name}. These are killed elsewhere.`);
  }

  closeDb() {
    console.warn(`Calling \`closeDb()\` on InMemoryPersister is a noop.`, this.name);
  }

  async initDataStore(storeConfigs) {
    Object.values(storeConfigs).forEach((storeConfig) => {
      const store = new LocalSessionStore(storeConfig.name, this.version, this.type);
      this.stores[storeConfig.name] = store;
    });
    return this;
  }
}

let localSessionPersister;

/**
 * Enforces a singleton pattern that always returns a promise resolving a single
 * instance of an LocalSessionPersister.
 * @param {Object} storeIdentifiers A lookup object of store identifiers.
 * @returns Promise<LocalSessionPersister>
 */
export const getLocalSessionPersister = async (name, storeIdentifiers = {}) => {
  if (localSessionPersister !== undefined) {
    return localSessionPersister;
  }
  localSessionPersister = new LocalSessionPersister(name);

  return localSessionPersister.initDataStore(storeIdentifiers);
};
